import mutations from './mutations';
import StateIdentifiers from './state-identifiers';

/**
 * Creates a store factory for module injection.
 * @param {string} storeModuleName
 * @returns {Function}
 */
export default function createStore({storeModuleName}) {
    const moduleDefinition = {
        namespaced: true,
        state: {
            // set a default loading state
            loadingComponents: [StateIdentifiers.application],
        },
        // mutations are used to do synchronous changes
        // to the state
        mutations: {
            [mutations.start](state, identifier) {
                state.loadingComponents.push(identifier);
                const unique = (value, index, origin) => origin.indexOf(value) === index;
                state.loadingComponents = state.loadingComponents.filter(unique);
            },
            [mutations.stop](state, identifier) {
                const index = state.loadingComponents.indexOf(identifier);
                if (index > -1) {
                    state.loadingComponents.splice(index, 1);
                }
            },
            [mutations.reset](state) {
                state.loadingComponents = [];
            },
        },
        actions: {
            [mutations.start]({commit}, identifier) {
                // triggers the start mutation
                commit(mutations.start, identifier);
            },
            [mutations.stop]({commit}, identifier) {
                // triggers the stop mutation
                commit(mutations.stop, identifier);
            },
            [mutations.reset]({commit}) {
                commit(mutations.reset);
            },
        },
        getters: {
            /**
             * Check whether the component identifier exists in the loading state.
             * @param {state} state
             * @returns {Function}
             */
            isLoading: state => (identifier => state
                .loadingComponents.find(id => id === identifier) !== undefined),
            /**
             * Checks whether there is at least one component that is currently loading
             * for this shared state store instance.
             * @param {state} state
             * @returns {boolean}
             */
            someLoading: state => state.loadingComponents.length > 0,
        },
    };
    return (store) => {
        // register a module dynamically with the name value provided
        store.registerModule(storeModuleName, moduleDefinition);
    };
}
